export interface SalesDespatchAnalysis {
  dateOrdered: Date;
  orderNo: string;
  customerOrderRef: string;
  orderType: string;
  customerKey: string;
  customerName: string;
  internalCustomer: string;
  brand: string;
  customerCategory: string;
  vatRegNumber: string;
  country: string;
  customerOrderNo: string;
  contractNo: number;
  preBuyOrder: string;
  fromPreBuyOrder: string;
  productType: string;
  productKey: string;
  oldCode: string;
  productDescription: string;
  makeUp: string;
  customerLineRef: string;
  internalNotes: string;
  noOfItems: number;
  quantity: number;
  despatchedQty: number;
  balance: number;
  balanceSterlingValue: number;
  unitOfMeasure: string;
  priceListQty: number;
  conversionUnitOfMeasure: string;
  price: number;
  discount: number;
  discountAmount: number;
  currencyCode: string;
  currencyValue: number;
  currencyDiscountValue: number;
  rate: number;
  sterlingValue: number;
  sterlingDiscountValue: number;
  deliveryDate: Date;
  promisedDate: Date;
  customerType: string;
  customerSubType: string;
  salesDiscount: string;
  despatchNoteNo: number;
  despatchDate: Date;
  trackingNumber: string;
  shipper: string;
  paymentTerms: string;
  deliveryTerms: string;
  settlementTerms: string;
  modeOfTransport: string;
  orderSource: string;
  orderStatus: string;
  sellingCompany: string;
  enteredBy: string;
  customerContact: string;
  tax: string;
  port: string;
  certificationRequired: string;
  deliveryAddress: string;
  deliveryCountry: string;
  deliveryAddressName: string;
  deliveryAddressLine1: string;
  deliveryAddressLine2: string;
  deliveryAddressLine3: string;
  deliveryAddressLine4: string;
  deliveryAddressTownCity: string;
  deliveryAddressRegion: string;
  deliveryAddressPostCode: string;
  billingAddress: string;
  billingAddressName: string;
  billingAddressLine1: string;
  billingAddressLine2: string;
  billingAddressLine3: string;
  billingAddressLine4: string;
  billingAddressTownCity: string;
  billingAddressRegion: string;
  billingAddressPostCode: string;
  billingCountry: string;
  productGroup: string;
  productCategory: string;
  cRMRef: string;
  postcode: string;
  deliveryAddressee: string;
  exportOrder: string;
}
